import { DefaultUrlSerializer, UrlTree } from "@angular/router";

export class CustomUrlSerializer extends DefaultUrlSerializer {
  override parse(url: string): UrlTree {
    try {
      return super.parse(url);
    } catch (error) {
      // Return a fallback UrlTree (e.g., to the root or a 404 page)
      // Since specific 404 route handling depends on the app, we fallback to default logic or root if preferred.
      // Based on previous intent, trying '/404' or just handling gracefully.
      // If '/404' is not defined, it will match wildcard or nothing.
      return super.parse("/404");
    }
  }
}
